import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/flexible/Paginated';
import { Role, RoleOptions } from 'models/flexible/User';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminRolesQueryKeys = {
  index: (params?: Record<string, any>) => ['adminRoles', params] as const,
};

type AdminRoleIndexParams = BaseIndexQueryParams & {
  'name.not'?: string;
};

export async function adminIndexRoles(params?: AdminRoleIndexParams, signal?: GenericAbortSignal) {
  return http.get<Paginated<RoleOptions>>('admin/roles', { params, signal }).then((res) => ({
    ...res.data,
    data: (res.data.data ?? []).map((x) => new Role(x)),
  }));
}
